/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-08-12T15:42:30.837
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportRentContractCard,
	getReportRentContractCardCreateInit,
	getReportRentContractCardEditInit,
	getReportRentContractCardView,
	deleteReportRentContractCard
} from '@api/report/ReportRentContractCard';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportRentContractCardCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractCardCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportRentContractCardEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractCardEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportRentContractCard({}, ReportRentContractCard) {
			return new Promise((resolve, reject) => {
				saveReportRentContractCard(ReportRentContractCard)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportRentContractCardView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractCardView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportRentContractCard({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractCard({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
